import { ExamineeRegistrationStatus } from '@exam-center/graphql';
import { SearchRoundedIcon, TextField, SearchMultipleSelection, Flex } from '@shared/components';
import debounce from 'lodash/debounce';

import { useProctoringRegistrationExamineeListSearchParams } from '../../hooks';

const registrationStatusOptionLabelMap: Record<string, string> = {
  [ExamineeRegistrationStatus.NotRegistered]: 'ยังไม่ได้ลงทะเบียน',
  [ExamineeRegistrationStatus.Registered]: 'ลงทะเบียนแล้ว',
  [ExamineeRegistrationStatus.Failed]: 'ลงทะเบียนไม่สำเร็จ',
};

export default function RegistrationExamineeSearchBox() {
  const [
    { search, registrationStatus },
    { changePageNumber, changeSearch, changeRegistrationStatus },
  ] = useProctoringRegistrationExamineeListSearchParams();

  const debouncedSearch = debounce((searchString: string) => {
    changeSearch(searchString);
    changePageNumber(0);
  }, 700);

  const mockRegistrationStatusOptions = Object.values(ExamineeRegistrationStatus).map((status) => ({
    label: registrationStatusOptionLabelMap[status],
    value: status,
  }));

  return (
    <Flex
      sx={(theme) => ({
        gap: theme.spacing(4),
        flexDirection: {
          mobile: 'column',
          tablet: 'row',
        },
      })}
    >
      <TextField
        label='ค้นหา'
        defaultValue={search}
        placeholder='ค้นหาชื่อผู้เข้าสอบ'
        name='search'
        slotProps={{
          input: {
            startAdornment: (
              <SearchRoundedIcon sx={{ color: (theme) => theme.palette.grey[500] }} />
            ),
          },
        }}
        sx={{
          width: {
            mobile: '100%',
            tablet: '300px',
          },
        }}
        onChange={(event) => {
          debouncedSearch(event.target.value);
        }}
      />
      <SearchMultipleSelection
        label='สถานะการลงทะเบียน'
        options={mockRegistrationStatusOptions}
        value={registrationStatus.map((status) => ({
          label: registrationStatusOptionLabelMap[status],
          value: status,
        }))}
        sx={{
          width: {
            mobile: '100%',
            tablet: '240px',
          },
        }}
        placeholder={registrationStatus.length === 0 ? 'แสดงทั้งหมด' : undefined}
        onChange={(_, value) => {
          const selectedValues = value.map((val) => val.value as ExamineeRegistrationStatus);
          changePageNumber(0);
          changeRegistrationStatus(selectedValues);
        }}
      />
    </Flex>
  );
}
